/* =========================================================
   Ürün kartı görsel galerisi — koleksiyon/anasayfa kartlarında
   swipe (mobil) + ok/nokta (masaüstü hover) ile görsel geçişi.
   Tamamen event-delegated: kart DOM'u yeniden render olsa
   (ör. variant-siblings.js section swap) yeniden init gerekmez.
   ========================================================= */
(function () {
  "use strict";

  var SWIPE_THRESHOLD = 40;

  var touchStartX = 0;
  var touchStartY = 0;
  var activeGallery = null;
  var isHorizontalSwipe = false;

  function getGallery(el) {
    var gallery = el.closest("[data-card-gallery]");
    if (gallery) return gallery;
    var card = el.closest(".product-card, [data-gallery-scope]");
    return card ? card.querySelector("[data-card-gallery]") : null;
  }

  /* Kart yatay kayan bir rayin icindeyse swipe RAYA aittir.
     Yoksa asagidaki touchmove preventDefault'u rayin native scroll'unu
     olduruyor ve 12 urunluk raydan sadece 2 kart erisilebilir kaliyor
     (mobilde .rail-nav oklari da gizli). Izgara sayfalarinda (koleksiyon,
     arama) yatay kaydirici yok, orada swipe galeriyi cevirmeye devam eder. */
  function insideHorizontalScroller(el) {
    var node = el.parentElement;
    while (node && node !== document.body) {
      if (node.scrollWidth - node.clientWidth > 4) {
        var overflowX = getComputedStyle(node).overflowX;
        if (overflowX === "auto" || overflowX === "scroll") return true;
      }
      node = node.parentElement;
    }
    return false;
  }

  function getSlides(gallery) {
    return gallery.querySelectorAll(".product-card__slide");
  }

  function getIndex(gallery) {
    return parseInt(gallery.getAttribute("data-index"), 10) || 0;
  }

  function setIndex(gallery, index) {
    var slides = getSlides(gallery);
    var count = slides.length;
    if (index < 0) index = 0;
    if (index > count - 1) index = count - 1;
    gallery.setAttribute("data-index", index);

    slides.forEach(function (slide, i) {
      slide.classList.toggle("is-active", i === index);
    });

    /* Nokta ve oklar galerinin kardeşi: kartta .product-card, hızlı bakış
       modalında [data-gallery-scope] sarmalayıcı. */
    var card = gallery.closest(".product-card, [data-gallery-scope]");
    if (!card) return;

    card.querySelectorAll("[data-card-dot]").forEach(function (dot, i) {
      dot.classList.toggle("is-active", i === index);
      dot.setAttribute("aria-current", i === index ? "true" : "false");
    });

    var prevBtn = card.querySelector("[data-card-prev]");
    var nextBtn = card.querySelector("[data-card-next]");
    if (prevBtn) prevBtn.disabled = index === 0;
    if (nextBtn) nextBtn.disabled = index === count - 1;
  }

  document.addEventListener("click", function (e) {
    var dot = e.target.closest("[data-card-dot]");
    if (dot) {
      e.preventDefault();
      var dotGallery = getGallery(dot);
      if (dotGallery) setIndex(dotGallery, parseInt(dot.getAttribute("data-goto"), 10));
      return;
    }

    var prevBtn = e.target.closest("[data-card-prev]");
    if (prevBtn) {
      e.preventDefault();
      var prevGallery = getGallery(prevBtn);
      if (prevGallery) setIndex(prevGallery, getIndex(prevGallery) - 1);
      return;
    }

    var nextBtn = e.target.closest("[data-card-next]");
    if (nextBtn) {
      e.preventDefault();
      var nextGallery = getGallery(nextBtn);
      if (nextGallery) setIndex(nextGallery, getIndex(nextGallery) + 1);
    }
  });

  document.addEventListener("touchstart", function (e) {
    var gallery = getGallery(e.target);
    if (!gallery || insideHorizontalScroller(gallery)) { activeGallery = null; return; }
    activeGallery = gallery;
    isHorizontalSwipe = false;
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
  }, { passive: true });

  document.addEventListener("touchmove", function (e) {
    if (!activeGallery) return;
    var dx = e.touches[0].clientX - touchStartX;
    var dy = e.touches[0].clientY - touchStartY;
    if (!isHorizontalSwipe && Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 10) {
      isHorizontalSwipe = true;
    }
    if (isHorizontalSwipe) e.preventDefault();
  }, { passive: false });

  document.addEventListener("touchend", function (e) {
    if (!activeGallery || !isHorizontalSwipe) { activeGallery = null; return; }
    var dx = e.changedTouches[0].clientX - touchStartX;
    if (Math.abs(dx) > SWIPE_THRESHOLD) {
      setIndex(activeGallery, getIndex(activeGallery) + (dx < 0 ? 1 : -1));
    }
    activeGallery = null;
    isHorizontalSwipe = false;
  });
})();
